import { Component, OnDestroy, OnInit } from '@angular/core';

/**
 * Layout layar kasir: header All In One (logo, tema, menu akun) tanpa sidebar dan breadcrumb.
 * Dipakai semua akun yang punya cashpay.use, termasuk admin yang membukanya dari menu "Kasir".
 */
@Component({
  selector: 'app-cashier-layout',
  templateUrl: './cashier-layout.component.html',
  styleUrls: ['./cashier-layout.component.scss'],
})
export class CashierLayoutComponent implements OnInit, OnDestroy {
  ngOnInit(): void {
    // Tanpa sidebar, konten tidak boleh menyisakan margin kiri selebar sidebar.
    document.body.classList.add('sidebar-hidden');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('sidebar-hidden');
  }
}
